module.exports = __webpack_public_path__ + "static/img/5.14e613d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel-2/5.jpg
// module id = iP/+
// module chunks = 1